var HORIZONTAL_LINE_INSIDE_MACRO = '---';
export default function getRuleNodeView(schema, containerNodeType) {
  var _schema$nodes = schema.nodes,
    paragraph = _schema$nodes.paragraph,
    rule = _schema$nodes.rule;
  if (containerNodeType) {
    var textNode = schema.text(HORIZONTAL_LINE_INSIDE_MACRO);
    return paragraph.createChecked({}, textNode);
  } else {
    return rule.createChecked();
  }
}
export function createRuleNode(schema) {
  var rule = schema.nodes.rule;
  var ruleNode = rule.createChecked();
  return [ruleNode];
}